/* eslint-disable react/jsx-no-bind */

import { useState } from "react";

import SearchField from "app/components/shared/SearchField";
import Icon from "app/components/shared/Icon";

import { Markdown } from "../Markdown";
import { GuideAttribute } from "./GuideAttribute";
import { attributeDoesMatchFilter } from "./utils";
import { useGuides } from "./useGuide";
import { HighlightProvider } from "../useHighlight";

export function GuideItem() {
  const { selectedAttribute, selectedItem: item, onClearItem } = useGuides();

  const [attributeFilter, setAttributeFilter] = useState("");

  if (!item) {
    return null;
  }

  const matchedContentAttributes = item.attributes
    .filter((attribute) => attributeDoesMatchFilter(attribute, attributeFilter))
    .map((attribute) => (
      <GuideAttribute
        key={attribute.name}
        attribute={attribute}
        active={attribute === selectedAttribute}
      />
    ));

  return (
    <>
      <div className="sticky -top-3 z-10 -mx-3 -mt-3">
        <div className="flex h-[39px] items-center gap-2 border-b border-gray/50 bg-white/90 px-3 backdrop-blur">
          <button
            onClick={onClearItem}
            className="-mx-2 flex h-7 items-center gap-1 rounded px-2 font-medium hover:bg-gray-200"
          >
            <Icon icon="heroicons/16/solid/arrow-left" className="block size-4" /> Back
          </button>

          {item.docsURL && (
            <a
              href={item.docsURL}
              target="_blank"
              rel="noreferrer noopener"
              className="purple hover-purple hover-underline ml-auto flex items-center gap-1 font-medium"
            >
              Docs
              <Icon icon="heroicons/16/solid/arrow-up-right" className="block size-4" />
            </a>
          )}
        </div>
      </div>

      <h2 className="my-0 text-base font-semibold">{item.name}</h2>

      {item.textContent ? (
        <Markdown>{item.textContent}</Markdown>
      ) : item.shortDescription ? (
        <p>{item.shortDescription}</p>
      ) : null}

      {item.attributes.length > 0 && (
        <>
          <h3 className="my-0 text-base">Attributes</h3>

          <SearchField
            className="[&_input]:h-8"
            onChange={setAttributeFilter}
            placeholder="Filter attributes..."
          />

          {matchedContentAttributes.length > 0 ? (
            <HighlightProvider value={attributeFilter}>
              <div className="space-y-3">{matchedContentAttributes}</div>
            </HighlightProvider>
          ) : (
            <p className="my-0 text-charcoal-300">
              No {item.name.toLowerCase()} attributes match “{attributeFilter}”.
            </p>
          )}
        </>
      )}
    </>
  );
}
